<div #waveformContainer class="waveform" class="band-on-waveform"></div>
